import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=c9a4174a&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=c9a4174a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9a4174a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c9a4174a')) {
      api.createRecord('c9a4174a', component.options)
    } else {
      api.reload('c9a4174a', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=c9a4174a&scoped=true&", function () {
      api.rerender('c9a4174a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-20PG6paUVJ6g1/JS/comp/PopupBox.vue"
export default component.exports